export default "__VITE_ASSET__c48b94c3__"